import { render } from "./EditDropdownGrouped.vue?vue&type=template&id=f2f0008a&scoped=true"
import script from "./EditDropdownGrouped.vue?vue&type=script&lang=js"
export * from "./EditDropdownGrouped.vue?vue&type=script&lang=js"

import "./EditDropdownGrouped.vue?vue&type=style&index=0&id=f2f0008a&lang=css&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f0008a"]])

export default __exports__